module.exports = __webpack_public_path__ + "static/media/river.20a2bcb0.png";